import React, { useEffect, useState } from 'react';
import { BsArrowLeftShort } from 'react-icons/bs';
import { FiSearch } from 'react-icons/fi';
import { GoPlus } from 'react-icons/go';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';

import { useActiveTab } from '../../../../../components/map/components/hooks/useActiveTab';
import { setEditingPinId } from '../../../../../store/slices/projectItemSlice';
import { handleBlockEnter } from '../../../Helpers/constants/constant'; 
  
import AmenityItem from './components/AmenityItem'; 
import { useAmenityList } from './hooks/useAmenityList'; 
import { fetchAmenityIcons } from './services/amenityService';
import { decode } from '../../../../../helpers/utils';


const AmenitySideBar = () => {

    useActiveTab('all');
    
    const dispatch    = useDispatch();
    const navigate    = useNavigate();
    const { id }      = useParams();
    const decodedId   = decode(id);
    const pinsLoaded  = useSelector((state) => state.api.pinsLoaded);

    const [mapDivSize, setMapDivSize] = useState(window.innerHeight );
    const [amenityIcons, setAmenityIcons] = useState([]); 
    
    const {
        filteredList,
        searchTerm,
        setSearchTerm,
        handleAddNew,
        handleEdit,
        handleRemove,
        handleCreateAmenity,
    } = useAmenityList();
 
    
    useEffect(() => {
        dispatch(setEditingPinId(null));
    }, []);

    useEffect(() => {
        fetchIcons(decodedId);
    }, [decodedId]);

    const fetchIcons = async (id) =>{
        let response = await fetchAmenityIcons(id)
        setAmenityIcons(response)
    }
    
    useEffect(() => {
        const handleResize = () => setMapDivSize(window.innerHeight);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const goBack = () => {
        navigate(-1);
        setSearchTerm('');
    };

    return (
        <div className="bar" id="inner-customizer2" style={{ position: 'relative', height: mapDivSize, paddingBottom: '20px' }} >
            <Row className='backRow'>
                <Col md={8}>
                    <h1> Amenity Pins</h1>
                </Col>
                <Col md={4} >
                    <div className='backArrow float-right' onClick={goBack}>
                        <BsArrowLeftShort />
                    </div>
                </Col>
            </Row>

            <Formik
                initialValues={{
                    amenity_name: '! New amenity',
                    enc_id: null,
                    position: null, 
                    icon: amenityIcons[0]?.enc_id, 
                    icon_id: amenityIcons[0]?.enc_id,
                }} 
                onSubmit={handleCreateAmenity} 
            >
                {({
                    handleSubmit, 
                }) => (
                    <> 
                        <form
                            id="productForm"
                            className="av-tooltip tooltip-label-bottom formGroups"
                            style={{height:"calc(100vh - 90px)"}}
                            onSubmit={(e) => handleSubmit(e)}
                        >
                            { 
                                <>
                                    <div className='bar-sub-header' style={{ marginRight: '14px' }}>
                                        <p style={{ marginTop: 0 }} >Add New Amenity Pin</p>
                                        <div className='plus-icon' onClick={() => handleAddNew()}>
                                            <GoPlus />
                                        </div>
                                    </div> 
 

                                    <div className="d-flex bar-search mb-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search..."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                            onKeyDown={(e) => handleBlockEnter(e)}
                                        />
                                        <div
                                            className="input-group-append"
                                            style={{ marginLeft: "-36px" }}
                                        >
                                            <span
                                                className="input-group-text"
                                                style={{
                                                    border: "none",
                                                    backgroundColor: "transparent",
                                                    padding: '4px'
                                                }}
                                            >
                                                <FiSearch className="iconStyle" />
                                            </span>
                                        </div>
                                    </div>

                                    <div className='custom-scrollbar customScroll' style={{
                                        height: "100%"
                                    }} >
                                        {!pinsLoaded ? (
                                            <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 40 }}>
                                                <div className="spinner-border text-primary" role="status">
                                                    <span className="sr-only">Loading…</span>
                                                </div>
                                            </div>
                                        ) : filteredList.map((amenity, idx) => (
                                            <AmenityItem
                                                key={amenity.enc_id}
                                                index={idx}
                                                amenity={amenity}
                                                onEdit={handleEdit}
                                                onRemove={handleRemove}
                                            />
                                        ))}
                                    </div>
                                </>
                            }
 
                            <Button 
                                type="submit" 
                                id='amenitySubmitBtn'
                                hidden
                            >
                                Submit
                            </Button> 

                        </form>
                    </>
                )}
            </Formik>
             
        </div>
    )
}

export default AmenitySideBar

